import { Component, ChangeDetectionStrategy, Input, ViewChild, signal } from '@angular/core';

import { TranslocoDirective } from '@ngneat/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { PricingError } from '@pedix-workspace/utils';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';

@Component({
    selector: 'pxw-pricing-errors-dialog',
    templateUrl: './pricing-errors-dialog.component.html',
    styleUrls: ['./pricing-errors-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent, CurrencyFormatPipe]
})
export class PricingErrorsDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  pricingErrors = signal<PricingError[]>([]);

  open(pricingErrors: PricingError[]) {
    this.pricingErrors.set(pricingErrors);

    return this.modalDialog.open().catch(() => {});
  }
}
